import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';

export const usePermissions = () => {
  const context = useContext(AuthContext);
  
  if (!context) {
    throw new Error('usePermissions must be used within an AuthProvider');
  }
  
  const { user, permissions } = context;

  const hasPermission = (module: string, action: string): boolean => {
    // Nếu user có role admin, luôn trả về true
    if (user?.roleKey?.toLowerCase() === 'admin' || user?.roleKey?.toLowerCase() === 'quản trị viên') {
      return true;
    }

    // Tìm module trong permissions
    const modulePermission = permissions?.find(
      (p: any) => (p.modulekey || p.module || '').toLowerCase() === module.toLowerCase()
    );

    if (!modulePermission) return false;

    // Kiểm tra action cụ thể
    switch (action) {
      case 'view':
        return modulePermission.view || modulePermission.all;
      case 'edit':
        return modulePermission.edit || modulePermission.all;
      case 'add':
        return modulePermission.add || modulePermission.all;
      case 'delete':
        return modulePermission.delete || modulePermission.all;
      case 'all':
        return modulePermission.all;
      default:
        return false;
    }
  };

  return { hasPermission };
};
